import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CertificadosComponent } from './components/certificados/certificados.component';
import { AuthGuard } from 'src/app/guards/auth.guard';
import { LoginComponent } from 'src/app/components/login/login.component';
import { AuthComponent } from './components/auth/auth/auth.component';


const routes: Routes = [ 
  {path: '', redirectTo: '/certificados', pathMatch: 'full' },
  { path: 'auth', component: AuthComponent },
  {path: 'consulta-certificado-inacal', redirectTo: '/certificados', pathMatch: 'full' },
  {path:"certificados", component: CertificadosComponent },
  {path:"certificados/:codigoHash", component: CertificadosComponent },
  {path:"login", component: LoginComponent},
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
